import React from 'react'
import PropTypes from 'prop-types'
import { CheckCircle, Clock, FileText, Loader, Shield, TrendingUp, XCircle } from 'lucide-react'

// Matches the visual style of gl-badge from golive.css
const BADGE_BASE = 'inline-flex items-center gap-[5px] px-[10px] py-[3px] rounded-full text-xs font-semibold whitespace-nowrap'

const STATUS_META = {
  queued:    { label: 'Queued',    icon: Clock,        cls: 'bg-[#f1f5f9] text-[#475569]' },
  running:   { label: 'Running',   icon: Loader,       cls: 'bg-[#dbeafe] text-[#2563eb]' },
  completed: { label: 'Completed', icon: CheckCircle,  cls: 'bg-[#dcfce7] text-[#16a34a]' },
  failed:    { label: 'Failed',    icon: XCircle,      cls: 'bg-[#fee2e2] text-[#dc2626]' },
}

const TYPE_META = {
  smp:  { label: 'SMP',  icon: FileText, cls: 'bg-[#dbeafe] text-[#2563eb]' },
  raid: { label: 'RAID', icon: Shield,   cls: 'bg-[#e0e7ff] text-[#4338ca]' },
  tvr:  { label: 'TVR',  icon: TrendingUp, cls: 'bg-[#d1fae5] text-[#065f46]' },
}

export function JobStatusBadge({ status }) {
  const meta = STATUS_META[status] ?? { label: status, icon: null, cls: 'bg-gray-100 text-gray-600' }
  const Icon = meta.icon
  return (
    <span className={`${BADGE_BASE} ${meta.cls}`}>
      {Icon && <Icon size={11} />}
      {meta.label}
    </span>
  )
}

JobStatusBadge.propTypes = { status: PropTypes.string.isRequired }

export function JobTypeBadge({ type }) {
  const meta = TYPE_META[type] ?? { label: type.toUpperCase(), icon: null, cls: 'bg-gray-100 text-gray-600' }
  const Icon = meta.icon
  return (
    <span className={`${BADGE_BASE} ${meta.cls}`}>
      {Icon && <Icon size={11} />}
      {meta.label}
    </span>
  )
}

JobTypeBadge.propTypes = { type: PropTypes.string.isRequired }
